import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Plus } from 'lucide-react';

const SplitPayDialog = ({
  open,
  onOpenChange,
  calculateTotal
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader><DialogTitle>Split Payment</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">Total: <span className="font-bold">₹{calculateTotal().toFixed(2)}</span></p>
          <div className="space-y-3">
            {[1, 2].map(i => (
              <div key={i} className="flex items-center gap-2">
                <Label className="w-20">Person {i}</Label>
                <Input type="number" placeholder="Amount" className="flex-1" />
                <Select defaultValue="cash">
                  <SelectTrigger className="w-20"><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="cash">Cash</SelectItem>
                    <SelectItem value="card">Card</SelectItem>
                    <SelectItem value="upi">UPI</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            ))}
          </div>
          <Button variant="outline" size="sm"><Plus className="h-4 w-4 mr-1" /> Add Person</Button>
          <Button className="w-full" size="lg">Complete Split Payment</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SplitPayDialog;
